document.addEventListener('DOMContentLoaded', function() {
  var lang = document.documentElement.lang || 'en';
  var translations = {
    'en': 'Add to Cart',
    'fr': 'Ajouter au panier'
  };
  
  var button = document.getElementById('AddToCartText');
  if (button && translations[lang]) {
    button.textContent = translations[lang];
  }
  
  // Also update after variant changes
  setTimeout(function() {
    if (button && button.textContent.trim() === 'Add to Cart') {
      button.textContent = translations[lang];
    }
  }, 1000);
});
